import {loginActionTypes} from "./login.actionTypes";
import {Network} from "../../../utils/network";
import {globalConst} from "../../../utils/globalConstant";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {hideLoader} from "../../../commonComponents/Loader/loader.actions";
import {
  sendLoggedInMoengageEvent,
  setCountry,
} from "../../../utils/commonMethods";
import {profileActionTypes} from "../../Profile/redux/profile.actionTypes";
import {headerSet} from "../../../utils/networkFetch";
import CONFIG from "../../../config/config";

export const verifyMobile = mobileNo => async (dispatch, state) => {
  try {
    const res = await Network.verifyMobile({mobile: mobileNo});
    dispatch({
      type: loginActionTypes.VERIFY_MOBILE_SUCCESS,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: loginActionTypes.VERIFY_MOBILE_FAIL,
      payload: e.response,
    });
  }
};

export const registerUser =
  (mobileNo, source, country_code, email) => async (dispatch, state) => {
    try {
      let res;
      if (email) {
        headerSet(CONFIG.LOG_OUT_TOKEN);
        res = await Network.sendOTPEmail(
          {
            email: email,
            version: globalConst.appVersion,
          },
          true,
        );
      } else {
        res = await Network.sendOTP(
          {
            mobile: mobileNo,
            source: source,
            country_code: country_code,
            version: globalConst.appVersion,
          },
          true,
        );
      }
      // trackMoengageEvent("login_click", {mobileNo: mobileNo});
      dispatch({
        type: loginActionTypes.REGISTER_USER,
        payload: res?.status === 422 ? res?.data?.error : res.data,
      });
    } catch (e) {
      dispatch({
        type: loginActionTypes.REGISTER_USER_FAIL,
        payload: e.response,
      });
    } finally {
      dispatch(hideLoader());
    }
  };

export const registerUserInterim = statusVal => async (dispatch, state) => {
  dispatch({
    type: loginActionTypes.REGISTER_USER,
    payload: {success: statusVal},
  });
};

export const verifyUserInterim = statusVal => async (dispatch, state) => {
  dispatch({
    type: loginActionTypes.VERIFY_OTP,
    payload: false,
  });
};

export const setFirstLogin = statusVal => async (dispatch, state) => {
  dispatch({
    type: loginActionTypes.CHECK_FIRST_LOGIN,
    payload: statusVal,
  });
};

export const registerUserModalClose = () => async (dispatch, state) => {
  dispatch({
    type: loginActionTypes.REGISTER_USER_MODAL_CLOSE,
    payload: false,
  });
};

export const OTPLESS_VERIFY = res => async (dispatch, state) => {
  dispatch({
    type: loginActionTypes.VERIFY_OTP,
    payload: res?.status === 422 ? res?.data?.error : true,
  });
  if (res?.data) {
    setCountry(res?.data?.region_code);
    dispatch({
      type: profileActionTypes.SET_PROFILE,
      payload: res.data,
    });
  }
};

export const verifyOTP = (requestOtpData, email) => async (dispatch, state) => {
  try {
    // trackMoengageEvent("Login OTP", {
    //   mobilenumber: requestOtpData?.mobile,
    //   OTP: requestOtpData?.otp,
    // });
    let res;
    if (email) {
      res = await Network.verifyOTPEmail(requestOtpData);
    } else {
      res = await Network.verifyOTP(requestOtpData);
    }
    if (res?.data?.verified) {
      //dispatch(getUserProfile(requestOtpData?.mobile));
    }

    try {
      // await AsyncStorage.setItem('last_login', new Date());
      sendLoggedInMoengageEvent();
      await AsyncStorage.setItem("last_login", JSON.stringify(new Date()));
    } catch (error) {
      // Error saving data
    }
    dispatch({
      type: loginActionTypes.VERIFY_OTP,
      payload: res?.status === 422 ? res?.data?.error : res.data,
    });
  } catch (e) {
    dispatch({
      type: loginActionTypes.VERIFY_OTP_ERROR,
      payload: e.response,
    });
  } finally {
    dispatch(hideLoader());
  }
};

export const setShowLoginModal = (show, params = {}) => ({
  type: loginActionTypes.SHOW_LOGIN_MODAL,
  payload: show,
  params,
});

export const setLoggingIn = (val) => ({
  type: loginActionTypes.IS_LOGGING_IN,
  payload: val,
});

export const setMagicLinkAuthLoading = (val) => ({
  type: loginActionTypes.MAGIC_LINK_AUTH_LOADING,
  payload: val,
});
